import { WebsitesModal } from "../../components/modals/WebsitesModal/WebsitesModal";
import withOpportunityListModalTracked from "../ListModal/withOpportunityListModalTracked";

const WebsitesModalTracked = withOpportunityListModalTracked(WebsitesModal);

export default WebsitesModalTracked;
